export default angular.module('elfium', ['ngRoute', 'ui.bootstrap', 'toastr', 'xeditable', 'ngRadialGauge', 'daterangepicker', 'angularSpinner', 'ui.select', 'ngSanitize']);


// WEBPACK FOOTER //
// ./src/app/module.ts